import React from 'react';
import Proptypes from 'prop-types';
import { FormattedMessageAnchor } from '../../../commonComponents';

const ModalFooter = ({
  notAllow,
  allow,
  notAllowId = 'without_image.Allow',
  allowId = 'without_image.OK',
}) => (
  <footer className="modal--footer">
    <div className="modal--actions">
      <FormattedMessageAnchor
        id={notAllowId}
        defaultMessage="Don't Allow"
        className="modal--actions__item"
        onClick={notAllow}
      />
      <FormattedMessageAnchor
        id={allowId}
        defaultMessage="OK"
        className="modal--actions__item"
        onClick={allow}
      />
    </div>
  </footer>
);

ModalFooter.propTypes = {
  notAllow: Proptypes.func,
  allow: Proptypes.func,
  notAllowId: Proptypes.string,
  allowId: Proptypes.string,
};

export default ModalFooter;
